module.exports = __webpack_public_path__ + "img/Accounting.9275a678.svg";